import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function About() {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Quality Assurance',
      description: 'We source only premium products from trusted manufacturers to ensure long-lasting performance and customer satisfaction'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Customer First',
      description: 'Our dedicated team provides expert guidance and support to help you make the right choices for your projects'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Trust & Integrity',
      description: 'Built on years of honest business practices, we maintain transparency in pricing and product quality'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Innovation',
      description: 'We continuously update our inventory with the latest products and technologies in the sanitary and hardware industry'
    }
  ];

  const whyChoose = [
    'Over 15 years of experience in sanitary and hardware business',
    'Wide range of products from leading brands',
    'Competitive wholesale and retail pricing',
    'Expert product consultation and guidance',
    'Strong presence in Rawalpindi market',
    'Trusted by contractors, builders, and homeowners',
    'Quality products with warranty support',
    'Fast and reliable service'
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <WhatsAppButton />

      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-cover bg-center" style={{
        backgroundImage: `linear-gradient(rgba(0, 51, 102, 0.85), rgba(0, 102, 204, 0.75)), url('https://public.readdy.ai/ai/img_res/26096b68989d8ce2bbff14321051abd0.jpg')`
      }}>
        <div className="container mx-auto px-4 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">About Malik Brothers</h1>
          <p className="text-xl md:text-2xl">Building Trust Through Quality Since Years</p>
        </div>
      </section>

      {/* Company Introduction */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-center mb-8 text-gray-800">Who We Are</h2>
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                <strong className="text-blue-600">Malik Brothers</strong> is a leading name in the sanitary ware and hardware industry in Rawalpindi. With years of dedicated service, we have established ourselves as a trusted partner for contractors, builders, and homeowners seeking quality products at competitive prices.
              </p>
              <p>
                Located at <strong>Shop #3 Awan Plaza, Near Allied Bank, Qasim Market, Range Road, Rawalpindi</strong>, our store offers a comprehensive selection of bathroom sanitary items, kitchen fixtures, pipes, fittings, and hardware tools. We pride ourselves on maintaining a well-stocked inventory that meets the diverse needs of our customers.
              </p>
              <p>
                Our commitment to excellence extends beyond just selling products. We provide expert consultation, helping customers choose the right items for their specific requirements. Whether you're renovating a bathroom, setting up a new kitchen, or working on a large construction project, our knowledgeable team is here to guide you every step of the way.
              </p>
              <p>
                At Malik Brothers, we believe in building long-term relationships with our customers through honest business practices, transparent pricing, and exceptional after-sales support. Our reputation in the market is built on the foundation of quality, trust, and reliability.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-6xl mx-auto">
            <div className="bg-white p-10 rounded-xl shadow-md">
              <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mb-6">
                <i className="ri-eye-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-3xl font-bold mb-4 text-gray-800">Our Vision</h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                To become the most trusted and preferred destination for sanitary ware and hardware products in the region, known for our quality, service excellence, and customer satisfaction.
              </p>
            </div>
            <div className="bg-white p-10 rounded-xl shadow-md">
              <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mb-6">
                <i className="ri-compass-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-3xl font-bold mb-4 text-gray-800">Our Mission</h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                To provide high-quality sanitary and hardware products at competitive prices, backed by expert guidance and exceptional customer service, helping our customers bring their projects to life.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">Our Core Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="bg-gray-50 p-8 rounded-xl hover:shadow-lg transition-all">
                <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mb-6">
                  <i className={`${value.icon} text-3xl text-blue-600`}></i>
                </div>
                <h3 className="text-xl font-bold mb-3 text-gray-800">{value.title}</h3>
                <p className="text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-blue-600 text-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-16">Why Choose Malik Brothers</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
            {whyChoose.map((reason, index) => (
              <div key={index} className="flex items-start gap-4 bg-blue-700 p-6 rounded-lg">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-400"></i>
                </div>
                <p className="text-lg">{reason}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6 text-gray-800">Ready to Work With Us?</h2>
          <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto">
            Visit our store today or get in touch with our team for expert guidance on your sanitary and hardware needs
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a 
              href="tel:03135224547"
              className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              <i className="ri-phone-line text-xl"></i>
              Call Now
            </a>
            <a 
              href="https://wa.me/923135224547" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white px-10 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              WhatsApp Us
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}